import React, { useState } from "react";
import axios from "axios";


const useCheckin = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
}) => {
    const mainApi = '/koha/checkin'
    const [data, setData] = useState([])

    const getCheckinData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get(mainApi, {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data?.data || [])
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return {
                    ...data
                }
            });
    }
    //新增借書
    const postCheckinData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post(mainApi,
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                   
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })

    }
    //續借書
    const postCheckinRenewData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post(`/koha/Checkin/renew`,
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                   
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })

    }

    // const patchCheckinData = (data) => {
        
    //     onBefore({
    //         axiosMode: "patch"
    //     })
    //     axios.patch(mainApi,
            
    //             data
            
    //     )
    //         .then((response) => {
    //             let responseData = response.data
    //             let status = responseData?.status
    //             if (status === "fail") {
    //                 onFinish(
    //                     {
    //                         axiosMode: "patch",
    //                         status: "error"
    //                     }
    //                 )
    //             }
    //             else {
    //                 onFinish(
    //                     {
    //                         axiosMode: "patch",
    //                         status: "success"
    //                     }
    //                 )
    //             }
    //         })
    //         .catch(() => {
    //             onFinish(
    //                 {
    //                     axiosMode: "patch",
    //                     status: "error"
    //                 }
    //             )
    //         })
    // }
    // const deleteCheckinData = (data) => {
    //     onBefore({
    //         axiosMode: "delete"
    //     })
    //     axios.delete(mainApi,
    //         {
    //             data
    //         }
    //     )
    //         .then((response) => {
    //             let responseData = response.data
    //             let status = responseData?.status
    //             if (status === "fail") {
    //                 onFinish(
    //                     {
    //                         axiosMode: "delete",
    //                         status: "error"
    //                     }
    //                 )
    //             }
    //             else {
    //                 onFinish(
    //                     {
    //                         axiosMode: "delete",
    //                         status: "success"
    //                     }
    //                 )
    //             }
    //         })
    //         .catch(() => {
    //             onFinish(
    //                 {
    //                     axiosMode: "delete",
    //                     status: "error"
    //                 }
    //             )
    //         })
    // }
    return {
        CheckinData: data,
        getCheckinData,
        postCheckinData,
        postCheckinRenewData,
        // patchCheckinData,
        // deleteCheckinData,
    }
}
export { useCheckin }
